enum RecognitionHubViews {
  CARD_VIEW = "CARD_VIEW",
  POPUP_VIEW = "POPUP_VIEW"
}
export default RecognitionHubViews
